import { Link, Tooltip, Typography } from '@trustsecurenow/components-library';
import React from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { isNA } from '../helpers';

const AverageBFRCell = ({ averagePFR ='', clientId }) => {
  if (isNA(averagePFR)) return <Typography variant="body2">N/A</Typography>;

  return (
    <Tooltip title="Click here to navigate to the Phishing tab" placement="top">
      <Link
        underline="hover"
        hoverColor="info.main"
        variant="body2"
        component={RouterLink}
        to={`/clients/phishingReports/${clientId}`}
      >
        {`${averagePFR}%`}
      </Link>
    </Tooltip>
  );
};

AverageBFRCell.propTypes = {
  averagePFR: PropTypes.string.isRequired,
  clientId: PropTypes.string.isRequired
};

export default AverageBFRCell;
